import React, { useEffect, useState } from "react";
import { api } from "../../helpers/ApiHelper";
import { message, Select, Form } from "antd";
import strings from "../../utils/Localization";

const { Option } = Select;

function DepoSelectOption({
  formItemName,
  disabled,
  formItemLabel,
  required = true,
}) {
  const [depoData, setDepoData] = useState([]);
  const [fetchLoading, setFetchLoading] = useState(false);
  const { depoPlaceHolder } = strings.depoSelectOption;

  useEffect(() => {
    fetchDepo();
  }, []);

  const fetchDepo = async () => {
    try {
      setFetchLoading(true);

      const response = await api.post("/stokdepo/get", {});
      if (response.status === 200) {
        setDepoData(response.data.data);
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Form.Item
      name={formItemName}
      label={formItemLabel}
      rules={[{ required: required }]}
    >
      <Select
        placeholder={depoPlaceHolder}
        loading={fetchLoading}
        disabled={disabled}
      >
        {depoData.map((item, index) => (
          <Option key={index} value={String(item.id)}>
            {item.ad}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
}

export default DepoSelectOption;
